<div class="p-a-6 p-l-4-m p-l-4-s p-r-4-m p-r-4-s bg-col-w b-radius-4 m-t-4 m-t-2-s b-a b-col-5">
    @if (sectionTitle) {
    <div class="flex flex-middle">
        @if (sectionIcon) {
        <i [ngClass]="'icon-' + sectionIcon"
           class="m-r-3"></i>
        }
        <h5 class="s1 inline-block va-m flex-grow">{{ sectionTitle }}</h5>
        <button class="p2"
                inlineButton
                [status]="actionStatus"
                [notification]="'Error'"
                (click)="action.emit()">{{ actionCopy}} </button>
    </div>
    }
    <ng-content select="[sectionInside]"></ng-content>
</div>
<ng-content select="[sectionBelow]"></ng-content>
